import * as exodusCrypto from '@exodus/crypto/randomUUID';
export const randomBytes = (length) => {
    const bytes = new Uint8Array(length);
    crypto.getRandomValues(bytes);
    return Buffer.from(bytes);
};
export const randomUUID = () => {
    if (typeof crypto !== 'undefined' &&
        typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    // this fallback needs to be resolved to the native implementation, see https://github.com/ExodusMovement/passkeys/blob/9a23903c96b68e6746df987c28986d4120bfe3c8/apps/signer-relay/vite.config.ts#L28-L33
    return exodusCrypto.randomUUID();
};
export const encrypt = async (data, key) => {
    const iv = window.crypto.getRandomValues(new Uint8Array(12));
    const encrypted = await window.crypto.subtle.encrypt({
        name: 'AES-GCM',
        iv,
    }, key, typeof data === 'string' ? Buffer.from(data, 'utf8') : data);
    return Buffer.concat([iv, Buffer.from(encrypted)]);
};
export const decrypt = async (data, key) => {
    const iv = data.subarray(0, 12);
    const encrypted = data.subarray(12);
    const decrypted = await window.crypto.subtle.decrypt({
        name: 'AES-GCM',
        iv,
    }, key, encrypted);
    return Buffer.from(decrypted);
};
export const generateKey = async () => window.crypto.subtle.generateKey({
    name: 'AES-GCM',
    length: 256,
}, true, ['encrypt', 'decrypt']);
